<template>
  <div>
    <component :is="currentComponent" v-if="currentComponent" :readonly="readonly" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Aspirant from './exams/_Aspirant'
import Magistrant from './exams/_Magistrant'
import Bachelor from './exams/_Bachelor'
import { useApplicationStore } from '@widgets/application-profile'

const store = useApplicationStore()

const components = {
  aspirant: Aspirant,
  magistrant: Magistrant,
  bachelor: Bachelor,
}

const currentComponent = computed(() => components[store.application?.education_level])

defineProps({
  readonly: { type: Boolean, default: false },
})
</script>
